import { PostHogProvider as Provider } from 'posthog-js/react'
import { Fragment } from 'react/jsx-runtime'
import { isDevelopment } from 'utils'

export function PostHogProvider(p: any) {
  if (isDevelopment) return <Fragment {...p} />

  return (
    <Provider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{ api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST }}
      {...p}
    />
  )
}
